import { authService } from '../services/AuthService'
import { localStorageService } from '../services/LocalStorageService'

const authenticationStore = {
  namespaced: true,
  state: {
    authenticatedUser: null
  },
  mutations: {
    setAuthenticatedUser: (state, user) => {
      delete user.password
      state.authenticatedUser = user
      localStorageService.setItem('authenticatedUser', user)
    },
    logoutUser: (state) => {
      state.authenticatedUser = null
    }
  },
  actions: {
    authenticate: async ({ commit }, credentials) => {
      let user = await authService.login(credentials)

      commit('setAuthenticatedUser', { ...user })
      return user
    },

    register: async ({ dispatch }, credentials) => {
      let user = await authService.register(credentials)
      if (user) dispatch('authenticate', credentials)
      return user
    },

    logout: async ({ commit }) => {
      localStorageService.removeItem('authenticatedUser')
      commit('logoutUser')
    },

    getFromLocalStorage: ({ commit }) => {
      const user = localStorageService.getItem('authenticatedUser')
      if (user) commit('setAuthenticatedUser', user)
    },

    refreshCurrentUser: async ({ state, commit }, user) => {
      const refreshedUser = await authService.refresh()
      return refreshedUser
    },

    authWithFacebook: async () => {
      const response = await authService.authWithFacebook()
      return response
    }
  },
  getters: {
    isAuthenticated: state => state.authenticatedUser !== null,
    currentUser: state => state.authenticatedUser ? state.authenticatedUser : null
  }
}

export default authenticationStore
